export const SUPPORTED_URL_PROTOCOLS = new Set([
  'http:',
  'https:',
  'mailto:',
  'sms:',
  'tel:',
]);

/**
 * Санитизация URL для защиты от XSS через `javascript:`-схему.
 *
 * Относительные URL без схемы безопасны и пропускаются как есть; URL со
 * схемой допускаются только для протоколов из белого списка, в остальных
 * случаях нейтрализуются в `about:blank`.
 */
export const sanitizeUrl = (url: string): string => {
  // Относительные URL, якоря и protocol-relative не имеют схемы и не могут
  // выполнить javascript:/data: и т.п.
  if (!/^[a-z][a-z0-9+.-]*:/i.test(url)) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);
    if (!SUPPORTED_URL_PROTOCOLS.has(parsedUrl.protocol)) {
      return 'about:blank';
    }
  } catch {
    return 'about:blank';
  }
  return url;
};
